/* eslint-disable react/prop-types */

import React, { Component, createElement } from "react";
import ReactDOM from "react-dom";
import "whatwg-fetch";
import Url from "url-parse";

class EducationFilterer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeFilters: this.parseQueryStringFilters(),
      searchString: this.parseQueryStringTextQuery(),
      filterVisibleOnMobile: false
    };
  }

  parseQueryStringFilters() {
    const url = new Url(window.location.href, true);
    const query = url.query;
    let activeFilters = new Array();

    if (Object.keys(url.query).length === 0) {
      return activeFilters;
    }

    Object.keys(query).forEach(key => {
      let values = query[key].split(",");

      values.forEach(value => activeFilters.push(`${key}__${value}`));
    });

    return activeFilters;
  }

  parseQueryStringTextQuery() {
    const url = new Url(window.location.href, true);
    const query = url.query.q;

    if (query === undefined) {
      return ""; // React state expects empty string if none
    }

    return query;
  }

  updateActiveFilters(name, value) {
    let activeFilters = this.state.activeFilters;

    const key = `${name}__${value}`;

    if (activeFilters.includes(key)) {
      activeFilters = activeFilters.filter(item => {
        return item !== key;
      });
    } else {
      activeFilters.push(key);
    }

    return activeFilters;
  }

  componentDidUpdate() {
    this.updateQueryString();
    this.retrieveResults();
  }

  updateQueryString() {
    let url = new Url(window.location.href, true);

    // Delete old keys so we can start fresh
    Object.keys(url.query).forEach(key => {
      delete url.query[key];
    });

    let query = {};

    // Build query string according to name=value1,value2 i.e. education_location=deventer,twello
    this.state.activeFilters.forEach(activeFilter => {
      let [key, value] = activeFilter.split("__");

      if (query.hasOwnProperty(key) !== true) {
        query[key] = value;
      } else {
        query[key] = query[key] + `,${value}`;
      }
    });

    // Add the q parameter to search text strings
    if (this.state.searchString !== "") {
      query["q"] = this.state.searchString;
    }

    url.set("query", Object.assign(url.query, query));

    // Reset pagination
    if (url.pathname.includes("/page/")) {
      url.set(
        "pathname",
        url.pathname
          .split("/")
          .slice(0, -3)
          .join("/") + "/"
      );
    }

    history.pushState({}, null, url);
  }

  retrieveResults() {
    let url = new Url(window.location.href, true);

    document.querySelector("#education-cards").style.display = "none";
    document.querySelector("#cards-placeholder").style.display = "block";

    fetch(url)
      .then(function(response) {
        return response.text();
      })
      .then(function(body) {
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(body, "text/html");
        const newCardsEl = htmlDocument.documentElement.querySelector(
          "#education-cards"
        );

        const oldCardsEl = document.querySelector("#education-cards");

        document
          .querySelector("#education-cards")
          .parentNode.replaceChild(newCardsEl, oldCardsEl);

        document.querySelector("#cards-placeholder").style.display = "none";
      });
  }

  handleCheckbox(e) {
    this.setState({
      activeFilters: this.updateActiveFilters(e.target.name, e.target.value)
    });
  }

  handleSearchButton(searchString) {
    this.setState({
      searchString: searchString
    });
  }

  handleToggleFilter(e) {
    this.setState({
      filterVisibleOnMobile: this.state.filterVisibleOnMobile === false
    });
  }

  filterGroupsCheckboxClasses() {
    if (this.state.filterVisibleOnMobile == true) {
      return "filter-groups__checkboxes filter-groups__checkboxes--is-visible-on-mobile";
    }

    return "filter-groups__checkboxes";
  }

  render() {
    return (
      <div className="filter-groups__inner">
        <div className="filter-groups__top">
          <FilterSearch
            onClickSearchButton={e => this.handleSearchButton(e)}
            onClickToggleFilter={e => this.handleToggleFilter(e)}
            searchString={this.state.searchString}
            placeholder="Vul een zoekterm in"
          />
        </div>
        <div className={this.filterGroupsCheckboxClasses()}>
          <FilterGroups
            filters={JSON.parse(this.props.filters)}
            activeFilters={this.state.activeFilters}
            onChangeCheckbox={e => this.handleCheckbox(e)}
          />
        </div>
      </div>
    );
  }
}

class FilterSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchString: props.searchString
    };
  }

  onChangeSearchString(e) {
    this.setState({
      searchString: e
    });
  }

  onClickSearchButton(e) {
    e.preventDefault();
    this.props.onClickSearchButton(this.state.searchString);
  }

  onKeyPressSearchButton(e) {
    if (e.key !== "Enter") {
      return;
    }
    this.props.onClickSearchButton(this.state.searchString);
  }

  render() {
    return (
      <div className="filter-group">
        <div className="filter-group__title">Zoek een opleiding</div>
        <div className="filter-group__field filter-group__field--is-search">
          <div className="filter-group__search">
            <input
              type="text"
              className="filter-group__search__input"
              placeholder={this.props.placeholder}
              value={this.state.searchString}
              onKeyPress={e => this.onKeyPressSearchButton(e)}
              onChange={e => this.onChangeSearchString(e.target.value)}
            />
            <button
              type="submit"
              className="filter-group__search__button"
              onClick={e => this.onClickSearchButton(e)}
            >
              <span className="filter-group__search__button__label">
                Zoeken
              </span>
            </button>
          </div>
          <button
            className="filter-group__toggle-filter"
            onClick={e => this.props.onClickToggleFilter(e)}
          >
            <span className="filter-group__toggle-filter__label">
              Open filters
            </span>
          </button>
        </div>
      </div>
    );
  }
}

class FilterGroups extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let filters = this.props.filters;

    const filterdItems = [
      "wildlife",
      "sportvisserij",
      "paardensport",
      "hoefsmid",
      "groene-retail",
      "grond-en-infra",
      "groen-cultuurtechniek",
      "geo-data-design",
      "dierenartsassistent-paraveterinair"
    ];

    return filters
      .filter(e => {
        return e.options.length > 0;
      })
      .map(filterGroup => (
        <div className="filter-group" key={filterGroup.slug}>
          <div className="filter-group__title">{filterGroup.label}</div>
          <FilterFields
            fields={filterGroup.options.filter(
              item => filterdItems.includes(item.slug) === false
            )}
            name={filterGroup.slug}
            activeFilters={this.props.activeFilters}
            onChangeCheckbox={e => this.props.onChangeCheckbox(e)}
          />
        </div>
      ));
  }
}

class FilterFields extends Component {
  constructor(props) {
    super(props);
  }

  handleOnChange(event) {
    this.setState({ name: event.target.value });
  }

  isChecked(slug) {
    return this.props.activeFilters.includes(slug);
  }

  render() {
    const options = this.props.fields;
    const listOptions = options.map(option => (
      <FilterFieldCheckbox
        key={option.slug}
        name={this.props.name}
        slug={option.slug}
        isChecked={this.isChecked(`${this.props.name}__${option.slug}`)}
        label={option.label}
        onChangeCheckbox={e => this.props.onChangeCheckbox(e)}
      />
    ));

    return <div className="filter-group__field">{listOptions}</div>;
  }
}

class FilterFieldCheckbox extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="checkbox">
        <input
          className="checkbox__input"
          type="checkbox"
          name={this.props.name}
          checked={this.props.isChecked}
          value={this.props.slug}
          id={this.props.slug}
          onChange={e => this.props.onChangeCheckbox(e)}
        />
        <label className="checkbox__label" htmlFor={this.props.slug}>
          {this.props.label}
        </label>
      </div>
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  let el = document.getElementById("filter-groups");
  if (el === null) {
    return;
  }

  ReactDOM.render(createElement(EducationFilterer, el.dataset), el);
});
